import React from 'react';

import { connect } from '@cerebral/react';
import { state } from 'cerebral';
import { withRouter } from 'react-router-dom';

import { data } from '../../../util/data';
import LoadingImage from '../../atoms/loading-image';
import Button from '../../atoms/button';

import './index.scss';

class GenderList extends React.Component {
  static defaultProps = {
    collection: null,
    firstCollection: null,
  };

  static clickLink(gender, ageGroup, collection, type) {}

  genders() {
    const collection = this.props.firstCollection;

    // Handle genderless collection
    if (collection.isGenderless) {
      const entries = [];
      if (collection.hasKids) {
        entries.push({ title: 'Kids', slug: 'all', hid: 'all', ageGroup: 'kids' });
      }
      if (collection.hasTeens) {
        entries.push({ title: 'Teens', slug: 'all', hid: 'all', ageGroup: 'teens' });
      }
      return entries;
    }

    const genderList = [];

    if (collection.hasKidsGirls) {
      genderList.push({
        title: 'Girls',
        slug: 'girls',
        hid: 'girls',
        ageGroup: 'kids',
      });
    }

    if (collection.hasKidsBoys) {
      genderList.push({
        title: 'Boys',
        slug: 'boys',
        hid: 'boys',
        ageGroup: 'kids',
      });
    }

    if (collection.hasTeensGirls && genderList.length < 2) {
      genderList.push({
        title: 'Teens',
        slug: 'girls',
        hid: 'girls',
        ageGroup: 'teens',
      });
    }

    return genderList;
  }

  goTo(gender, type = '') {
    return () => {
      this.props.history.push(
        `/shop/${gender.ageGroup}/${gender.slug}/${this.props.firstCollection.slug}/${type}`,
      );
    };
  }

  photoSource(gender, ageGroup) {
    // Handle genderless collections
    if (gender.slug === 'all') {
      if (gender.ageGroup === 'teens') {
        return this.props.firstCollection.photoTeenGirls?.large ||
               this.props.firstCollection.photoTeenBoys?.large ||
               this.props.firstCollection.photoGirls?.large;
      }
      return this.props.firstCollection.photoGirls?.large ||
             this.props.firstCollection.photoBoys?.large;
    }

    if (gender.ageGroup === 'teens') {
      if (this.props.firstCollection.photoTeenGirls) {
        return this.props.firstCollection.photoTeenGirls.large;
      }
      return this.props.firstCollection.photoGirls.large;
    }

    if (gender.slug === 'girls') {
      return this.props.firstCollection.photoGirls.large;
    }

    return this.props.firstCollection.photoBoys.large;
  }

  render() {
    if (!this.props.firstCollection) {
      return null;
    }

    return (
      <div className="gender-list">
        {this.genders().map((gender, index) => (
          <div key={'gender-list_' + gender.slug} className="gender-list__item">
            <h2 className="gender-list__title" onClick={this.goTo(gender)}>
              {gender.title}
            </h2>
            <div className="gender-list__photo" onClick={this.goTo(gender)}>
              <LoadingImage src={this.photoSource(gender)} />
            </div>
            <div
              className={
                'gender-list__content-box' +
                (index % 2 ? ' gender-list__content-box--alternate' : '')
              }
            >
              <h3 className="gender-list__subtitle">
                {this.props.firstCollection.title}
              </h3>
              <div className="gender-list__content-footer">
                <div className="gender-list__footer-item">
                  <Button
                    icon="image"
                    text={data.lookbook}
                    onClick={this.goTo(gender, 'lookbook')}
                  />
                </div>
                <div className="gender-list__footer-item">
                  <Button
                    icon="shopping-bag"
                    text={data.shop}
                    onClick={this.goTo(gender)}
                  />
                </div>
                <div className="gender-list__footer-item">
                  <Button
                    icon="image"
                    text={data.silhouettes}
                    onClick={this.goTo(gender, 'silhouettes')}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default withRouter(
  connect(
    {
      genders: state.shop.genders,
      firstCollection: state.shop.firstCollection,
    },
    GenderList,
  ),
);
